import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";

import {
  editMarkerOnSubmit,
  initializeEditMarker,
  createMarkerOnSubmit,
  deleteMarker,
  getMarkers,
} from "features/planner/planner.actions";

import {
  getActionDataStateFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import { getAccessControlButton } from "utils/component.util";
import { MARKER_FORM } from "features/planner/planner.constants";
import { getMarkersFromState } from "features/planner/planner.selectors";
import Marker from "features/planner/components/Card/EmployeeCard/Marker";
import { getModifiedByValue, hasRequiredAccessLevel } from "utils/app.util";
import { ACTIONS, SORT_DIRECTION } from "features/planner/planner.constants";
import MarkerForm from "features/planner/settings/markers/components/MarkerForm";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";

const SettingsMarkersContainer = ({
  Icon,
  markers,
  dataState,
  breadcrumb,
  dispatchOnLoad,
  crudAccessLevel,
  currentUserAppRoles,
  dispatchDeleteMarker,
  dispatchEditMarkerOnSubmit,
  dispatchCreateMarkerOnSubmit,
  dispatchInitializeEditMarker,
}) => {
  useEffect(() => {
    dispatchOnLoad();
  }, [dispatchOnLoad]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: marker => marker.get("name"),
      },
      {
        xs: true,
        component: Grid,
        zeroMinWidth: true,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteMarker,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteMarker],
  );

  const renderIcon = item => (
    <SortableListRowIcon transparent>
      <Marker size={32} marker={item} />
    </SortableListRowIcon>
  );

  const markerForm = {
    form: MARKER_FORM.ID,
  };

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      items={markers}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={MarkerForm}
      CreateEntityFormComponent={MarkerForm}
      SortableListProps={{
        Icon: null,
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        renderIcon: renderIcon,
        getKey: marker => marker.get("id"),
        defaultSortDirection: SORT_DIRECTION.ASC,
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditMarker
          : null,
      }}
      EditModalProps={{
        Icon: null,
        submitText: "Save",
        title: "Edit marker",
        formTitleField: MARKER_FORM.NAME,
        onSubmit: dispatchEditMarkerOnSubmit,
      }}
      CreateModalProps={{
        Icon: null,
        submitText: "Save",
        title: "New marker",
        onSubmit: dispatchCreateMarkerOnSubmit,
      }}
      editEntityForm={markerForm}
      createEntityForm={markerForm}
    />
  );
};

export default compose(
  connect(
    state => ({
      markers: getMarkersFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getActionDataStateFromState(state, ACTIONS.GET_MARKERS),
    }),
    {
      dispatchOnLoad: getMarkers,
      dispatchEditMarkerOnSubmit: editMarkerOnSubmit,
      dispatchDeleteMarker: deleteMarker,
      dispatchInitializeEditMarker: initializeEditMarker,
      dispatchCreateMarkerOnSubmit: createMarkerOnSubmit,
    },
  ),
)(SettingsMarkersContainer);
